import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContactTabGroupComponent } from './sk-contact-tab-group/contact-tab-group.component';
import { ContactInfoTabComponent } from './sk-contact-tab-group/contact-info-tab/contact-info-tab.component';
import { ContactPhoneTabComponent } from './sk-contact-tab-group/contact-phone-tab/contact-phone-tab.component';
import { ContactEmailTabComponent } from './sk-contact-tab-group/contact-email-tab/contact-email-tab.component';
import { SingleContactComponent } from './single-contact/single-contact.component';
import { ContactLocationTabComponent } from './sk-contact-tab-group/contact-location-tab/contact-location-tab.component';
import { ContactListComponent } from './contact-list/contact-list.component';
import { FormsModule } from '@angular/forms';
import { MaintContactFormModule } from '@shared/modules/maint-contact-form/maint-contact-form.module';
import { TranslationModule } from '@core/modules/translation/translation.module';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
  declarations: [
    ContactListComponent,
    SingleContactComponent,
    ContactTabGroupComponent,
    ContactInfoTabComponent,
    ContactLocationTabComponent,
    ContactEmailTabComponent,
    ContactPhoneTabComponent
  ],
  imports: [
    CommonModule,
    TranslationModule,
    FormsModule,
    MaintContactFormModule,

    // Angular Material
    MatInputModule,
    MatExpansionModule,
    MatButtonModule,
    MatIconModule,
    MatTabsModule
  ],
  exports: [
    ContactListComponent,
    SingleContactComponent,
    ContactTabGroupComponent,
    ContactInfoTabComponent,
    ContactLocationTabComponent,
    ContactEmailTabComponent,
    ContactPhoneTabComponent
  ]
})
export class ContactModule {}
